import { FC, ChangeEvent, useState } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import Pagination from '@material-ui/lab/Pagination'
import { useQuery } from 'react-query'
import { formatJSONDate } from 'yancey-js-util'
import { fetchPosts } from 'src/services'
import { Category } from 'src/types'
import Aside from 'src/components/Aside/Aside'
import Loading from 'src/components/Loading/Loading'
import { getText } from 'src/containers/Home/components/News'

const PostListContainer = styled.section`
  display: flex;
  margin: 0 auto;
  margin-top: 48px;
  max-width: 1200px;
`

const Article = styled.article`
  width: 100%;
  margin-left: 24px;

  h1 {
    margin-top: 0;
    margin-bottom: 48px;
    text-align: center;
  }
`

const Item = styled.li`
  display: flex;
  margin-bottom: 24px;
  list-style: none;
`

const Time = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
`

const TimeMonth = styled.p`
  margin: 0;
  padding: 10px;
  width: 55px;
  color: #6c6c6c;
  background: #e3e3e3;
  text-align: center;
`

const TimeYear = styled.p`
  margin: 0;
  padding: 10px;
  color: #fff;
  background: #018cb3;
  text-align: center;
`

const Description = styled.p`
  color: #606060;
  font-size: 13px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  p {
    text-indent: 0 !important;
  }
`

const Title = styled.h3`
  margin-top: 0;
  color: #000;
`

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 48px 0;
`

interface Props {
  queryKey: string
  title: string
  category: Category
}

const Post: FC<Props> = ({ queryKey, title, category }) => {
  const [currPage, setPage] = useState(1)
  const [enabled, setEnabled] = useState(true)

  const { data, isFetching, isLoading } = useQuery(
    queryKey,
    () => fetchPosts(category, currPage),
    {
      enabled,
      onSettled() {
        setEnabled(false)
      },
    },
  )

  // @ts-ignore
  const handlePageChange = (e: ChangeEvent<unknown>, val: number) => {
    setPage(val)
    setEnabled(true)
    window.scrollTo(0, 0)
  }

  if (isFetching || isLoading || !data) return <Loading />

  const { total, page, pageSize, posts } = data

  return (
    <PostListContainer>
      <Aside />
      <Article>
        <h1>{title}</h1>
        <ul>
          {posts.map((post) => {
            const [year, ...rest] = formatJSONDate(post.createdAt)
              .split(' ')[0]
              .split('-')
            return (
              <Item key={post._id}>
                <Time>
                  <TimeMonth>{rest.join('-')}</TimeMonth>
                  <TimeYear>{year}</TimeYear>
                </Time>

                <div>
                  <Link href={`/post/${post._id}`}>
                    <a>
                      <Title>{post.title}</Title>
                      <Description>{getText(post.contentRAW)}</Description>
                    </a>
                  </Link>
                </div>
              </Item>
            )
          })}
        </ul>

        {total === 0 || (
          <PaginationWrapper>
            <Pagination
              count={Math.ceil(total / pageSize)}
              color="primary"
              variant="outlined"
              page={page}
              onChange={handlePageChange}
            />
          </PaginationWrapper>
        )}
      </Article>
    </PostListContainer>
  )
}

export default Post
